import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import DesignButton from 'components/lv1/designButton'
import SelectLanguage from 'components/lv1/selectLanguage'
import StylesModule from 'components/lv3/subpageImage.module.scss'
import { MessageProps } from 'message/index.props'

export interface SubpageImageProps {
  message: MessageProps
  page: string
  src: string
}

const SubpageImage: FC<SubpageImageProps> = ({ message, page, src }) => {
  const classes = makeStyles(() => ({
    bgImage: {
      backgroundImage: `url(${src})`,
    },
  }))()
  return (
    <section>
      <div className={classNames(classes.bgImage, StylesModule.subpageImage)}>
        <div className={StylesModule.subpageImage__wrap}>
          <div className={StylesModule.subpageImage__languageWrap}>
            <SelectLanguage language={message.global.language} page={page} />
          </div>
          <div className={StylesModule.subpageImage__reservationWrap}>
            <DesignButton
              label={message.global.reservation}
              to={message.global.reservation_button.url}
              design="top-fill"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default SubpageImage
